export default __webpack_public_path__ + "static/media/offre.b936d561.jpg";